<template>
  <v-btn small fab color="gray" @click="$emit('click')">
    <v-icon>mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
export default {
name: "Back"
}
</script>

<style scoped>

</style>